import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowLeft } from "lucide-react";

const NotFoundPage = () => (
  <div className="min-h-[70vh] flex items-center justify-center bg-[#F7F5F0]" data-testid="not-found-page">
    <Helmet>
      <title>Page Not Found | DUGARS</title>
      <meta name="description" content="The page you're looking for doesn't exist." />
    </Helmet>
    <div className="text-center px-6">
      <p className="font-['Cormorant_Garamond'] text-8xl md:text-9xl font-light text-[#1C1C1A]/10 mb-4">404</p>
      <h1 className="font-['Cormorant_Garamond'] text-3xl md:text-4xl font-light text-[#1C1C1A] mb-4">Page Not Found</h1>
      <p className="text-[#6B6A65] font-light mb-8 max-w-md mx-auto">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link to="/" className="btn-primary inline-flex items-center gap-2" data-testid="back-home-btn">
        <ArrowLeft size={16} /> Back to Home
      </Link>
    </div>
  </div>
);

export default NotFoundPage;
